<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4 5.333c0 1.475 1.149 2.666 2.571 2.666h6.858v18.667c0 1.476 1.148 2.667 2.571 2.667 1.423 0 2.571-1.191 2.571-2.667V7.999h6.858C26.85 8 28 6.81 28 5.333s-1.149-2.667-2.571-2.667H6.57C5.15 2.666 4 3.857 4 5.333z"/></svg>
</template>

<script>
export default {
  name: 'editorTitleOutline'
}
</script>
